import { render, staticRenderFns } from "./addPassword.vue?vue&type=template&id=2ab31cda&scoped=true"
import script from "./addPassword.vue?vue&type=script&lang=js"
export * from "./addPassword.vue?vue&type=script&lang=js"
import style0 from "./addPassword.vue?vue&type=style&index=0&id=2ab31cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab31cda",
  null
  
)

export default component.exports